const TAG = 'AW-18020521522';
const destinations = {
  phone: `${TAG}/VmUvCJTQj6AcELKs7ZBD`,
  whatsapp: `${TAG}/tD0YCOiVurEdELKs7ZBD`,
};
const KEY = 'adsConsentV1';
declare global {
  interface Window { dataLayer?: unknown[]; gtag?: (...args: unknown[]) => void; }
}
let consent = false;
let loaded = false;
export function readAdsConsent() {
  try { return localStorage.getItem(KEY); } catch { return null; }
}
function command(...args: unknown[]) {
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer!.push(arguments); };
  window.gtag(...args);
}
export function setAdsConsent(accepted: boolean) {
  consent = accepted;
  try { localStorage.setItem(KEY, accepted ? 'granted' : 'denied'); } catch { /* Session-only consent. */ }
  command('consent', 'update', { ad_storage: accepted ? 'granted' : 'denied', ad_user_data: accepted ? 'granted' : 'denied', ad_personalization: 'denied', analytics_storage: 'denied' });
  if (accepted && !loaded) {
    loaded = true;
    command('js', new Date());
    command('config', TAG, { allow_ad_personalization_signals: false });
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${TAG}`;
    document.head.appendChild(script);
  }
}
export function initializeAds() {
  command('consent', 'default', { ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied', analytics_storage: 'denied' });
  if (readAdsConsent() === 'granted') setAdsConsent(true);
  let previous = { method: '', at: 0 };
  document.addEventListener('click', (event) => {
    const element = event.target instanceof Element ? event.target : null;
    const link = element?.closest<HTMLAnchorElement>('a[href]');
    if (!link || !consent) return;
    const url = new URL(link.href, location.href);
    let method: 'phone' | 'whatsapp' | undefined;
    if (url.protocol === 'tel:' && url.pathname.replace(/\D/g, '') === '351965715768') method = 'phone';
    if (url.hostname === 'wa.me' && url.pathname.replace(/\D/g, '') === '351965715768') method = 'whatsapp';
    if (url.hostname === 'api.whatsapp.com' && url.searchParams.get('phone')?.replace(/\D/g, '') === '351965715768') method = 'whatsapp';
    if (!method || (previous.method === method && Date.now() - previous.at < 1500)) return;
    previous = { method, at: Date.now() };
    const sameTab = link.target !== '_blank' && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0;
    let navigated = false;
    const navigate = () => { if (!navigated && sameTab) { navigated = true; location.href = link.href; } };
    if (sameTab) event.preventDefault();
    command('event', 'conversion', { send_to: destinations[method], value: 0, currency: 'EUR', event_callback: navigate, event_timeout: 800 });
    if (sameTab) setTimeout(navigate, 850);
  });
}
